import { DialogType } from '../../@types';
import { BettingActivity, Partner, WalletType } from '../../@types/api';
import { BETTING_ACTIVITY_OPTIONS, QUERY_KEYS, SPORTSBOOK_FROM_OPTIONS, SPORTSBOOK_WALLET_TYPE } from '../../constants';
import { BETTING_ACTIVITY } from '../../constants/enums';
import useFilterForm from '../../hooks/useFilterForm';
import { AdditionalQueryParams } from '../../hooks/usePagination';
import usePermissions from '../../hooks/usePermissions';
import FilterDialogLayout from '../layouts/FilterDialogLayout';
import FormSelect from '../molecules/FormSelect';
import FormAutocomplete from './FormAutocomplete';

export type FilterAgentsReportData = {
  managerIds?: string[];
  from?: string;
  walletType?: WalletType;
  bettingActivity?: BettingActivity;
};

type Props = DialogType & {
  changeQuery: (data: AdditionalQueryParams) => void;
};

const FilterAgentReport = ({ changeQuery, closeModal }: Props) => {
  const { isAgent } = usePermissions();

  const { control, handleSubmit, handleResetFilter, watch } = useFilterForm<FilterAgentsReportData>({
    defaultData: {
      managerIds: undefined,
      from: undefined,
      bettingActivity: BETTING_ACTIVITY.ACTIVE,
    },
    changeQuery,
  });

  const managerIds = watch('managerIds');

  const handleClose = () => {
    closeModal?.();
  };

  return (
    <FilterDialogLayout label='reports' onSave={handleSubmit} onClose={handleClose} onReset={handleResetFilter}>
      <FormAutocomplete<Partner, FilterAgentsReportData>
        name='managerIds'
        control={control}
        queryKey={[QUERY_KEYS.agentSearch, managerIds]}
        apiService='crm'
        url='agent/search'
        label='Managers'
        multiple
        queryParams={{
          roleTypes: ['Manager'],
        }}
        getOptionLabel={(options, value) => {
          const option = options.find((option) => option?.id === value);
          return option ? option.fullName : '';
        }}
      />
      <FormSelect name='from' control={control} label='From' options={SPORTSBOOK_FROM_OPTIONS} />
      {!isAgent && <FormSelect name='walletType' control={control} label='Bets' options={SPORTSBOOK_WALLET_TYPE} />}
      <FormSelect
        name='bettingActivity'
        control={control}
        label='Betting Activity'
        options={BETTING_ACTIVITY_OPTIONS}
      />
    </FilterDialogLayout>
  );
};

export default FilterAgentReport;
